import React from 'react'
import './noData.css'

export default function NoData({ children }) {
    return(
        <div className='noData'>
            { children }
        </div>
    )
}